<div class="list">
  <app-item
    *ngFor="let certificate of certificatesByYear; trackBy: trackByItems"
    (click)="downloadCertificate(certificate)">
    <app-ptrab-pt-withholding-certificate-item [certificate]="certificate"></app-ptrab-pt-withholding-certificate-item>
  </app-item>
</div>
